import { BaseEntity } from '../../models';
import { localFaturamentoAtivo } from './local-faturamento-situacao';
import { LocalFaturamentoConfiguracaoPedido } from './domain';

export interface ILocalFaturamentoPrazoEntrega {
    id: number;
    idLocalFaturamento: number;
    idEstado: number;
    uf: string;
    nomeEstado: string;
    diasEntrega: number;
}

export class LocalFaturamento implements BaseEntity, LocalFaturamentoConfiguracaoPedido {
    id: number;
    idEmpresa: number;
    codigo: string;
    nome: string;
    situacao: number;
    idEstado: number;
    padrao?: boolean;
    prazosEntrega?: ILocalFaturamentoPrazoEntrega[];

    // Configurações
    /** ID da API do Report referente a Empresa/Local de Faturamento para ser considerado na impressão */
    idApiReport: string

    // Configurações - Pedidos
    /** Indica se o Local de Faturamento deve expedir pedidos */
    expedirPedidos: boolean;

    // Integração ERP
    codigoIntegracaoErpEmpresa: string;

    constructor() {
        this.situacao = localFaturamentoAtivo.id;

        // Configurações - Pedidos
        this.expedirPedidos = true;
    }
}
